// @ts-ignore
import userAgent from 'lib/currentUserAgent';
import { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

function redirectIf(fn: () => boolean) {
  return function(redirectPath: string) {
    return function(_: RouterState, replaceWith: (location: LocationDescriptor) => void) {
      if (fn()) {
        replaceWith({ pathname: redirectPath });
      }
    };
  };
}

export const redirectIfMobile = redirectIf(() => !userAgent.isDesktop());
export const redirectIfDesktop = redirectIf(() => userAgent.isDesktop());
